<template>
  <div>
    <div class="blacks">
      <div class="blacks-main">
        <div class="title">
          您好 欢迎来到桔家云官网!
          <i class="iconfont icon-htmal5icon14"></i>
          {{city}}
        </div>
        <!-- <div><i class="iconfont &#xe602;"></i>{{city}}</div> -->
        <div class="title-right">
          <span class="Joinmy" @click="toghomecloud">
            <i class="iconfont icon-renyuan"></i>商户中心
          </span>
          <span class="divide">|</span>
          <span class="Joinmy" @click="joinmy">
            <i class="iconfont icon-RectangleCopy"></i>
            招商加盟
          </span>
          <span class="divide">|</span>
          <a rel="nofollow" href="https://www.jiazhuangpei.com/to-jpjj" target="_blank">
             <span class="Joinmy">
            <i class="iconfont icon-chuang"></i>
            软装选配
          </span>
          </a>
           <span class="divide">|</span>
          <span class="Joinmy">
            <i class="iconfont icon-dianhua"></i>
            全国客服热线:400-1868-666
          </span>
        </div>
      </div>
    </div>
    <!-- <div class="head"> -->
    <div class="navvvv">
      <div class="nav-text">
        <div class="lines">
          <img src="../../../../assets/images/jjylogo.jpg" />
        </div>
        <el-row>
          <el-col :span="24">
            <div class="menu">
              <el-menu
                :default-active="activeMenu"
                class="el-menu-demo"
                mode="horizontal"
               
                background-color="#ffffff"
                text-color="#666666"
                active-text-color="#bc001d"
                 ref="kzMenu"
              >
                <el-menu-item
                  @mouseenter="enter()"
                  @mouseleave="leave()"
                  @click="skip('/Newindex')"
                  index="/Newindex"
                >首页</el-menu-item>
                <el-submenu index="2">
                  <template slot="title">精选整装</template>
                  <el-menu-item index="/Lifecycle" @click="skip('/Lifecycle')">六大生命周期产品</el-menu-item>
                  <el-menu-item index="/Setmeal" @click="skip('/Setmeal')" >套餐介绍</el-menu-item>
                  <!-- <el-menu-item index="/Product" @click="skip('/Product')" >产品介绍</el-menu-item> -->
                </el-submenu>
                <el-submenu index="3">
                  <template slot="title">精选设计</template>
                  <el-menu-item index="/Designer"  @click="skip('/Designer')" >优秀设计师</el-menu-item>
                  <el-menu-item index="/Sketch" @click="skip('/Sketch')" >效果图赏析</el-menu-item>
                  <el-menu-item index="/Panorama" @click="skip('/Panorama')" >全景图赏析</el-menu-item>
                </el-submenu>
                <el-submenu index="4">
                  <template slot="title">精选装修</template>
                  <el-menu-item index="/DecorationCase" @click="skip('/DecorationCase')" >装修案例</el-menu-item>
                  <el-menu-item index="/DecorationProcess" @click="skip('/DecorationProcess')" >施工工艺</el-menu-item>
                  <el-menu-item index="/Onlinesite" @click="skip('/Onlinesite')" >在线工地</el-menu-item>
                      <el-menu-item index="/Renovationloan" @click="skip('/Renovationloan')" >装修贷款</el-menu-item>
                  <el-menu-item index="/DecoMethod" @click="skip('/DecoMethod')" >装修宝典</el-menu-item>
                </el-submenu>
                
                <el-submenu index="5">
                  <template slot="title">商务合作</template>
                  <el-menu-item index="/Newjoin" @click="skip('/Newjoin')" >我要加盟</el-menu-item>
                  <el-menu-item index="/NewManufacturer" @click="skip('/NewManufacturer')" >我是厂家</el-menu-item>
                </el-submenu>
                <!-- <el-submenu index="6">
                  <template slot="title">装修指南</template>
              
                </el-submenu> -->
                <el-menu-item index="/Productmall" @click="skip2('https://shop.ghomecloud.com/index')" >产品商城</el-menu-item>
                <el-menu-item index="/NewFreeRegistration" @click="skip('/NewFreeRegistration')" >免费报名</el-menu-item>
                <el-menu-item index="/NewAbouts" @click="skip('/NewAbouts')" >关于我们</el-menu-item>
                <!-- <el-menu-item index="8" @click="skip('/NewAbouts')" >关于我们</el-menu-item> -->
              </el-menu>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>
<script>
import BaiduMap from "vue-baidu-map";
import Vue from "vue";
export default {
  props: ["nub"],
  watch: {
    nub: "getnub"
  },
  data() {
    return {
      activeIndex2: "1",
      city: "",
      province: "",
      area: "",
      location: null
    };
  },
   computed: {
  // 使用计算属性来获取到当前点击的菜单的路由路径，然后设置default-active中的值
  // 使得菜单在载入时就能对应高亮
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      // 可以在路由配置文件中设置自定义的路由路径到meta.activeMenu属性中，来控制菜单自定义高亮显示
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    }
  },
  methods: {
    skip(item) {
      this.$router.push({ path: item });
    },
        skip2(item) {
       window.open(item, "");
    },
   
    joinmy() {
      this.$router.push({ path: "/NewJoin" });
    },
    toghomecloud() {
      window.open("https://dd.ghomecloud.com", "");
    }
  },
  mounted() {
    let self = this;
    let getposition = (this.userinfo = JSON.parse(
      localStorage.getItem("position")
    ));
    if (getposition == undefined) {
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(function(r) {
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
          const myGeo = new BMap.Geocoder();
          myGeo.getLocation(new BMap.Point(r.point.lng, r.point.lat), data => {
            if (data.addressComponents) {
              const result = data.addressComponents;
              const location = {
                creditLongitude: r.point.lat,
                creditLatitude: r.point.lng,
                creditProvince: result.province || "",
                creditCity: result.city || "",
                creditArea: result.district || "",
                creditStreet:
                  (result.street || "") + (result.streetNumber || "")
              };
              self.location = location;
              //console.log('self.location',self.location);
              self.city = self.location.creditCity;
              self.province = self.location.creditProvince;
              self.area = self.location.creditArea;
              let position = {
                city: self.location.creditCity,
                province: self.location.creditProvince,
                area: self.location.creditArea
              };
              let setposition = localStorage.setItem(
                "position",
                JSON.stringify(position)
              );
              let getposition = (this.userinfo = JSON.parse(
                localStorage.getItem("position")
              ));
              self.$emit("positions", getposition);
            } else {
              // console.log('wwwww');
              self.city = "厦门市";
              self.province = "福建省";
              self.area = "";
              let position = {
                city: "厦门市",
                province: "福建省",
                area: ""
              };
              let setposition = localStorage.setItem(
                "position",
                JSON.stringify(position)
              );
              let getposition = JSON.parse(localStorage.getItem("position"));
              self.$emit("positions", getposition);
            }
          });
        }
      });
    } else {
      let getposition = JSON.parse(localStorage.getItem("position"));
      if (getposition) {
        //console.log('getposition',getposition);
        self.city = getposition.city;
        self.province = getposition.province;
        self.area = getposition.area;
        self.$emit("positions", getposition);
      }
    }
  },
  created: async function() {
    let self = this;
   
  }
};
</script>
<style>
.lines {
  width: 230px;
  height: 85px;
  line-height: 58px;
  position: relative;
  z-index: 999;
}
.divide {
  margin: 0 18px;
  font-size: 15px;
  font-weight: bolder;
}
.Joinmy {
  color: #fff;
  font-size: 13px;
  line-height: 30px;
  cursor: pointer;
}
.lines img {
  height: 100%;
  object-fit: fill;
  object-fit: contain;
  object-fit: scale-down;
}
.navvvv {
  width: 100%;
  height: 90px;
  background-color: #ffffff;
  box-shadow: 0px 8px 13px 0px rgba(1, 1, 1, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
}
.menu {
  margin-left: 151px;
}
.nav-text {
  width: 1280px;
  display: flex;
}
.blacks {
  width: 100%;
  height: 41px;
  background: #333;
}
.blacks-main {
  width: 1280px;
  margin: 0 auto;
}
.title {
  color: #fff;
  font-size: 13px;
  line-height: 40px;
  float: left;
}
.title-right {
  color: #fff;
  font-size: 13px;
  line-height: 40px;
  float: right;
}
.icon-htmal5icon14 {
  color: #c81622;
}
.navvvv .el-menu--horizontal > .el-submenu .el-submenu__title,
.navvvv .el-menu--horizontal > .el-menu-item {
  height: 85px !important;
  line-height: 85px !important;
  font-size: 15px;
}
.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu {
}
.navvvv .el-submenu__title i {
  color: #666666 !important;
}
.el-menu-item:hover {
  color: #fff !important;
  background-color: #bc001d !important;
}
.el-menu--collapse .el-menu .el-submenu,
.el-menu--popup {
  min-width: 120px !important;
  text-align: center;
}
.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  height: 45px;
  line-height: 45px;
  font-size: 15px;
}
.navvvv .el-menu--horizontal > .el-submenu .el-submenu__title,
.navvvv .el-menu--horizontal > .el-menu-item {
  width: 110px !important;
}
.navvvv .el-menu.el-menu--horizontal {
  border: none !important;
}
/* .el-menu--horizontal>.el-submenu .el-submenu__title:hover{
  text-decoration: underline !important;
} */
a{text-decoration: none;}
</style>
